import axios from 'axios';
import { variables } from "../Variables";

export const deleteEstateFreeSlotEventsFromDB = async (clientId, estateId) => {
    let url = variables.API_URL + `LocalEvents/DeleteEventsByEstateId?clientId=${clientId}&estateId=${estateId}`;
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
    };

    let response = await axios.post(url, {}, config);

    return response.data;
}